/* eslint-disable no-use-before-define */
import instance, { bffUrl, getToken, instanceClean, jwtUrl, pendingActivitiesApiUrl } from '../service.parameters';

/**
 * Get the pending activities of the user
 * @access public
 * @async
 * @returns {UserPendingProductDataModel[]}
 */
export const getUserPendingProducts = async () => {
  if (process.env.NODE_ENV === 'dev') {
    return new Promise((resolve, reject) => {
      resolve({
        data: [
          {
            title: 'Confirma tu propuesta de Seguro Scotia Salud 1',
            description: 'Tienes una propuesta de Seguro Scotia Salud pendiente para tu aprobación',
            hyperlink_name: 'Confirmar propuesta',
            hyperlink_ref: '/mfe-insurance-proposal-retake-web-cl/param/0b3de218-1f33-4d18-b605-3d3491eb52f7',
            icon: 'ICONBILLSILLUSTRATIVEREVERSED',
            days_left: 11,
            actions: [],
          },
          {
            title: 'Confirma tu propuesta de Seguro Scotia Salud 2',
            description: 'Tienes una propuesta de Seguro Scotia Salud pendiente para tu aprobación',
            hyperlink_name: 'Confirmar propuesta',
            hyperlink_ref: '/mfe-insurance-proposal-retake-web-cl/param/3ee2c4f8-49d7-4c7f-937f-6e7db5120fe3',
            icon: 'ICONBILLSILLUSTRATIVEREVERSED',
            days_left: 3,
            actions: [],
          },
          {
            title: 'Confirma tu propuesta de Seguro Scotia Salud 3',
            description: 'Tienes una propuesta de Seguro Scotia Salud pendiente para tu aprobación',
            hyperlink_name: 'Confirmar propuesta',
            hyperlink_ref: '/mfe-insurance-proposal-retake-web-cl/param/3ee2c4f8-49d7-4c7f-937f-6e7db5120fe3',
            icon: 'ICONBILLSILLUSTRATIVEREVERSED',
            days_left: 9,
            actions: [],
          },
          {
            title: 'Confirma tu propuesta de Seguro Scotia Salud 4',
            description: 'Tienes una propuesta de Seguro Scotia Salud pendiente para tu aprobación',
            hyperlink_name: 'Confirmar propuesta',
            hyperlink_ref: '/mfe-insurance-proposal-retake-web-cl/param/3ee2c4f8-49d7-4c7f-937f-6e7db5120fe3',
            icon: 'ICONBILLSILLUSTRATIVEREVERSED',
            days_left: 7,
            actions: [],
          },
          {
            title: 'Confirma tu propuesta de Seguro Scotia Salud 5',
            description: 'Tienes una propuesta de Seguro Scotia Salud pendiente para tu aprobación',
            hyperlink_name: 'Confirmar propuesta',
            hyperlink_ref: '/mfe-insurance-proposal-retake-web-cl/param/3ee2c4f8-49d7-4c7f-937f-6e7db5120fe3',
            icon: 'ICONBILLSILLUSTRATIVEREVERSED',
            days_left: 3,
            actions: [],
          },
        ],
      });
    });
  }

  try {
    const jwtUri = await jwtUrl();
    const passportUri = `${jwtUri}?TMPL=/security/passport.json&intends=`;
    const tokenResponse = await fetch(passportUri);
    const tokenJson = await tokenResponse.json();
    const url = await pendingActivitiesApiUrl();
    const rut = await getClientRut();
    const options = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${tokenJson.token}`,
      },
    };
    const response = await fetch(`${url}/pending_activities/${rut}`, options);
    const pendingProductsJson = await response.json();
    return pendingProductsJson.data.map(item => UserPendingProductDataModel(item));
    // eslint-disable-next-line sonarjs/no-useless-catch
  } catch (error) {
    throw error;
  }
};
/**
 * Get the current logged user executive information
 */
export const getExecutive = async () => {
  const url = await bffUrl();
  return instance.get(`${url}customers/executive`);
};

// const temp = {
//   accounts: {
//     checking_accounts: [
//       {
//         product_information: {
//           id: "974937131",
//           display_id: "0009 7493 7131",
//           product_category: "Account",
//           product_type: "checking_account",
//           product_name: "Cuenta Corriente",
//           is_data_fully_filled: false,
//         },
//         available_balance: {
//           amount: 2459117,
//           currency_code: "CLP",
//         },
//         countable_balance: {
//           amount: 2459117,
//           currency_code: "CLP",
//         },
//       },
//     ],
//     debit_accounts: [
//       {
//         product_information: {
//           id: "000976514459",
//           display_id: "0009 7651 4459",
//           product_category: "Account",
//           product_type: "debit_account",
//           product_name: "Cuenta Renta Diaria",
//         },
//         available_balance: {
//           amount: 5059376,
//           currency_code: "CLP",
//         },
//         countable_balance: {
//           amount: 5059376,
//           currency_code: "CLP",
//         },
//       },
//     ],
//   },
// }

/**
 * Get the current logged user products information filtered by
 * category and products
 *
 * @param {String} category
 * @param {String} products
 */
export const getProducts = async ({ category, products, customerColor }) => {
  //  return Promise.resolve({ data: temp });
  const url = await bffUrl();

  if (customerColor)
    return instance.get(`${url}products/${category}?customer_color=${customerColor}&types=${products}`);

  return instance.get(`${url}products/${category}?types=${products}`);
};
/**
 * Get the current logged user basic Information
 * @returns {String} data.firstName
 * @returns {String} data.lastName
 * @returns {String} data.gender
 */
export const getCustomerInformation = async () => {
  const url = await bffUrl();
  return instance.get(`${url}customers/info`);
};
const decodeJwt = token => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(c => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );
  return JSON.parse(jsonPayload);
};
export const getClientRut = async () => {
  const token = await getToken({ tokenIntends: '' });

  return decodeJwt(token).sub;
};
export const setDataJsonFingerPrint = async _data => {
  const jsonBase64 = btoa(JSON.stringify(_data));

  instanceClean
    .get(`/cgi-bin/transac/dotrxajax?TMPL=%2Fahorro%2Fsaldo.json&TRANS=vt_finger_print&json=${jsonBase64}`)
    // eslint-disable-next-line no-unused-vars
    .then(response => {}, error => {});
};

const defaultUserPendingProductDataModelArgs = { actions: [] };
/**
 * Constructor for UserPendingProductDataModel
 * @constructor
 * @access public
 * @class
 * @classdesc This class exists in order to document the data contract between client and server.
 * @param {Object} args
 * @param {string} args.title - Title of the pendency.
 * @param {string} args.description - Description of the pendency.
 * @param {string} args.responsive_description - Description of the pendency for small screen size.
 * @param {string} args.hyperlink_name - Text to be shown of the Hyperlink.
 * @param {string} args.hyperlink_ref - Destination of the Hyperlink.
 * @param {string} args.icon - Name of the icon of the pendency.
 * @param {number} args.days_left - Days left to overdue the pendency.
 * @param {UserPendencyActionDataModel[]} args.actions - Actions related to de pendency.
 */
export const UserPendingProductDataModel = (args = defaultUserPendingProductDataModelArgs) => ({
  title: args.title,
  description: args.description,
  responsive_description: args.responsive_description,
  hyperlink_name: args.hyperlink_name,
  hyperlink_ref: args.hyperlink_ref,
  icon: args.icon,
  days_left: args.days_left,
  actions: (args.actions || []).map(item => UserActionDataModel(item)),
});

const defaultUserActionDataModelArgs = {};
/**
 * Constructor for UserActionDataModel
 * @constructor
 * @access public
 * @class
 * @classdesc This class exists in order to document the data contract between client and server.
 * @param {Object} args
 * @param {string} args.name - Caption of the action.
 * @param {string} args.link - URL of the action.
 */
export const UserActionDataModel = (args = defaultUserActionDataModelArgs) => ({
  name: args.name,
  link: args.link,
});

// const mockToPendingProductDataModel = [
//   UserPendingProductDataModel({
//     title: 'Firma tu seguro Hogar de UF 0,23 mensuales',
//     description: 'Tienes una propuesta de Seguro Scotiahome Flex que está pendiente de tu aprobación.',
//     responsive_description: 'Seguro Scotiahome Flex',
//     hyperlink_name: 'Confirmar propuesta',
//     hyperlink_ref: '/mfe-scotiahome-insurance-web-cl/param/asdasd',
//     icon: 'insurance-illustrative',
//     days_left: 2,
//     actions: [
//       UserActionDataModel({ name: 'Continuar contratación', link: '/mfe-scotiahome-insurance-web-cl/param/asdasd' }),
//       UserActionDataModel({ name: 'Cancelar propuesta', link: '/mfe-scotiahome-insurance-web-cl/param/asdasd' })
//     ],
//   }),
//   UserPendingProductDataModel({
//     title: 'Sube los documentos para tu Hipotecario',
//     description: 'Tienes una solicitud de {crédito por UF 4.500}. Sube los documentos para continuar tu proceso',
//     responsive_description: '{crédito por UF 4.500}',
//     hyperlink_name: 'Subir documentos',
//     hyperlink_ref: '/mfe-scotiahome-insurance-web-cl/param/asdasd',
//     icon: 'insurance-illustrative-reversed',
//     days_left: 0,
//     actions: [
//       UserActionDataModel({ name: 'Subir documentos', link: '/mfe-scotiahome-insurance-web-cl/param/asdasd' }),
//     ],
//   }),
//   UserPendingProductDataModel({
//     title: 'Continua tu cotización de Crédito de Consumo',
//    description: 'Estuviste {cotizando por nuestra web} un Crédito de Consumo . Continúa el proceso dónde lo dejaste',
//     responsive_description: '{cotizando por nuestra web}',
//     hyperlink_name: 'Continuar mi cotización',
//     hyperlink_ref: '/mfe-scotiahome-web-cl/pending-product/34243432',
//     icon: 'mobile-illustrative-reversed',
//     days_left: -3,
//     actions: [
//       UserActionDataModel({ name: 'Continuar contratación', link: '/mfe-scotiahome-insurance-web-cl/param/asdasd' }),
//       UserActionDataModel({ name: 'Cancelar propuesta', link: '/mfe-scotiahome-insurance-web-cl/param/asdasd' })
//     ],
//   }),
//   UserPendingProductDataModel({
//     title: 'Tu tarjeta ****7689 ha sido bloqueada',
//     description: 'Te has quedado {sin tarjetas habilitadas para pagar.}',
//     responsive_description: '{sin tarjetas habilitadas para pagar.}',
//     hyperlink_name: 'Solicitar nueva tarjeta',
//     hyperlink_ref: '/mfe-scotiahome-insurance-web-cl/param/asdasd',
//     icon: 'my-activity-illustrative-reversed',
//     days_left: -1,
//     actions: [
//      UserActionDataModel({ name: 'Solicitar nueva tarjeta', link: '/mfe-scotiahome-insurance-web-cl/param/asdasd' }),
//     ],
//   }),
//   UserPendingProductDataModel({
//     title: 'Actualiza tu celular seguro',
//  description: 'Parece que tu celular registrado no está actualizado. Confirma tus datos para mantener tu',
//     responsive_description: '{Confirma tus datos}',
//     hyperlink_name: 'Confirmar datos',
//     hyperlink_ref: '/mfe-scotiahome-insurance-web-cl/param/asdasd',
//     icon: 'request-money-illustrative-reversed',
//     days_left: 1,
//     actions: [
//       UserActionDataModel({ name: 'Confirmar datos', link: '/mfe-scotiahome-insurance-web-cl/param/asdasd' }),
//     ],
//   }),
// ];
